module.exports = __webpack_public_path__ + "static/media/02_06.4c21e919.png";